import type { ModalFactory } from '../../../vend-ui/types'
import promotionModalTemplate from './promotion-modal.html'

/**
 * Service class for promotion detail modal.
 *
 * @class PromotionModalService
 */
export class PromotionModalService {
  constructor(private readonly Modal: ModalFactory) {
    'ngInject'
  }

  /**
   * Open the promotion detail modal.
   *
   * @method openPromotion
   *
   * @return {ModalInstance} The instance of the modal.
   */
  public openPromotion(options: any) {
    return this.Modal({
      controller: 'promotionModalController',
      controllerAs: '$ctrl',
      template: promotionModalTemplate,
      defaultTab: options.defaultTab,
      promotion: options.promotion,
      totalCustomerGroups: options.totalCustomerGroups,
      lineItemIds: options.lineItemIds,
      isTaxExclusive: options.isTaxExclusive,
      currencyDetails: options.currencyDetails,
    })
      .then((modal: $TSFixMe) => modal.closed)
      .catch(() => {}) // Empty catch here to avoid raygun unhandled rejection error when press Esc to close the modal
  }
}
